import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import { Box, Heading, Text, Link, HStack, Image } from "@chakra-ui/react";

const GameDetail = () => {
  const [singleData, setSingleData] = useState([]);
  const { id } = useParams();
  useEffect(() => {
    const fetchGame = async () => {
      if (id) {
        const result = await axios.get(
          `https://backendexample.sanbersy.com/api/data-game/${id}`
        );
        const {
          name,
          singlePlayer,
          multiplayer,
          platform,
          release,
          genre,
          image_url,
        } = result.data;
        setSingleData({
          name,
          singlePlayer,
          multiPlayer: multiplayer,
          platform,
          release,
          genre,
          image: image_url,
        });
      }
    };
    fetchGame();
  }, []);
  console.log(singleData);

  return (
    <Box p={8}>
      <HStack align="flex-start" spacing="20px">
        <Box>
          <Image
            boxSize="400px"
            objectFit="cover"
            loading="lazy"
            src={singleData.image}
            alt={singleData.name}
          />
        </Box>
        <Box>
          <Heading as="h1" size="lg">
            {singleData.name}
          </Heading>
          <Text>Platform: {singleData.platform}</Text>
          <Text>Genre: {singleData.genre}</Text>
          <Text>Release Year: {singleData.release}</Text>
          <Text>Single Player: {singleData.singlePlayer ? "Yes" : "No"}</Text>
          <Text>Multi Player: {singleData.multiPlayer ? "Yes" : "No"}</Text>
          <Link
            href={`https://www.youtube.com/results?search_query=${singleData.title} trailer`}
            mt={6}
            isExternal
          >
            Watch trailer on Youtube <ExternalLinkIcon mx="2px" />
          </Link>
        </Box>
      </HStack>
    </Box>
  );
};

export default GameDetail;
